import React from 'react';
import { services, unstable } from '@broadleaf/admin-components';
import OriginalHeader from '@broadleaf/admin-components/dist/view/named-components/view-types/EntityView/components/Header';
import OriginalLongHeader from '@broadleaf/admin-components/dist/view/named-components/view-types/EntityLongView/components/Header';
import EntityLongView from '@broadleaf/admin-components/dist/view/named-components/view-types/EntityLongView';
import AuroraHeader from './AuroraHeader';
import { ReadOnlyBannerTrigger } from './ReadOnlyBannerTrigger';

const { ComponentRegistrar } = services;
const { EntityView } = unstable;

ComponentRegistrar.registerComponent('blHeader', AuroraHeader);

// 1. Define custom headers wrapping the default ones
const AuroraEntityViewHeader: React.FC<
  React.ComponentProps<typeof OriginalHeader>
> = props => {
  return (
    <>
      <ReadOnlyBannerTrigger state={props.state} />
      <OriginalHeader {...props} />
    </>
  );
};

const AuroraEntityLongViewHeader: React.FC<
  React.ComponentProps<typeof OriginalLongHeader>
> = props => {
  return (
    <>
      <ReadOnlyBannerTrigger state={props.state} />
      <OriginalLongHeader {...props} />
    </>
  );
};

// 2. Only supply overridden components; EntityView and EntityLongView handle merging automatically
const customEntityViewComponents = {
  Header: AuroraEntityViewHeader
};

const customEntityLongViewComponents = {
  Header: AuroraEntityLongViewHeader
};

// 3. Create wrappers for EntityView and EntityLongView that inject their respective custom headers
const CustomEntityView: React.FC<
  React.ComponentProps<typeof EntityView>
> = props => {
  const mergedComponents = React.useMemo(
    () => ({
      ...props?.components,
      ...customEntityViewComponents
    }),
    [props?.components]
  );

  return <EntityView {...props} components={mergedComponents} />;
};

const CustomEntityLongView: React.FC<
  React.ComponentProps<typeof EntityLongView>
> = props => {
  const mergedComponents = React.useMemo(
    () => ({
      ...props?.components,
      ...customEntityLongViewComponents
    }),
    [props?.components]
  );

  return <EntityLongView {...props} components={mergedComponents} />;
};

// 4. Register the overridden view types correctly
ComponentRegistrar.registerViewComponent('ENTITY', CustomEntityView);
ComponentRegistrar.registerViewComponent(
  'ENTITY_LONG_FORM',
  CustomEntityLongView
);
